export default __webpack_public_path__ + "static/uscis-abca69784aa944ee4a818d6111d8c671.svg";